import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";
import { loggedInUser } from "../utils/store";
import { get } from "../server";
import Loader from "../components/Loader";
import showToast from "../helpers/showToast";
import { USER_STATS } from "../utils/constants/apiUrl";
import { FaNfcDirectional } from "react-icons/fa6";
import { BsQrCode } from "react-icons/bs";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement, // ✅ Import this
} from "chart.js";

import { Bar, Doughnut } from "react-chartjs-2";
import { Card, ProgressBar } from "react-bootstrap";
import nfc from "../assets/images/function_page_icons/nfc.svg";
import qrscan from "../assets/images/function_page_icons/qrscan.svg";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement // ✅ Register this
);
const UserStats = ({ percentage = 54 }) => {
  const [loggedUser] = useAtom(loggedInUser);
  //const [userTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(false);
  const [statsData, setStatsData] = useState({});
  const [isNFCStatsActive, setIsNFCStatsActive] = useState(true);
  const [isQRCodeStatsActive, setIsQRCodeStatsActive] = useState(false);
  const [isFunctionsStatsActive, setIsFunctionsStatsActive] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let current = 0;
    const interval = setInterval(() => {
      if (current >= percentage) {
        clearInterval(interval);
      } else {
        current++;
        setProgress(current);
      }
    }, 20);
    return () => clearInterval(interval);
  }, [percentage]);

  const handleNFCStats = () => {
    setIsQRCodeStatsActive(false);
    setIsFunctionsStatsActive(false);

    setIsNFCStatsActive(!isNFCStatsActive);
  };
  const handleQRCodeStats = () => {
    setIsNFCStatsActive(false);
    setIsFunctionsStatsActive(false);
    setIsQRCodeStatsActive(!isQRCodeStatsActive);
  };
  const handleFunctionsStats = () => {
    setIsNFCStatsActive(false);
    setIsQRCodeStatsActive(false);
    setIsFunctionsStatsActive(!isFunctionsStatsActive);
  };

  const getStats = async () => {
    setLoading(true);

    let { status, message, data } = await get(
      USER_STATS,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setStatsData(data);
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  useEffect(() => {
    getStats();
  }, []);

  if (loading) {
    return <Loader />;
  }

  const data = {
    labels: ["NFC Stat", "QR Scan"],
    datasets: [
      {
        data: [
          statsData?.totalUserNfcStatCount || 0,
          statsData?.totalFunctionQRStatCount || 0,
        ],
        borderColor: "#09A0FF", // Optional: different colors
        backgroundColor: "#E8F6FF", // Optional: different border colors
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // 👈 This disables the legend
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <>
      <div className="heading">
        <h1>Stats</h1>
      </div>
      {/* <div className="boxWrapper">
        <div className={`d-flex align-items-center gap-2 mainWrapper`}>
          <div
            className="statsBoxWrapper"
            onClick={handleNFCStats}
            style={{
              border: isNFCStatsActive
                ? "2px solid var(--primary_button_color)"
                : "2px solid var(--border_color)",
            }}
          >
            <div>
              <img src={nfcscannedIcon} alt="Icon" width="50px" height="50px" />
            </div>
            <div>
              <h6 className="counter">{statsData.totalUserNfcStatCount}</h6>
              <h6 className="totalTite">Lifetime Taps</h6>
            </div>
          </div>

          <div
            className="statsBoxWrapper"
            onClick={handleFunctionsStats}
            style={{
              border: isFunctionsStatsActive
                ? "2px solid var(--primary_button_color)"
                : "2px solid var(--border_color)",
            }}
          >
            <div>
              <img src={qrcodescanned} alt="Icon" width="50px" height="50px" />
            </div>
            <div>
              <h6 className="counter">{statsData.totalFunctionQRStatCount}</h6>
              <h6 className="totalTite">Lifetime QR Code Scans</h6>
            </div>
          </div>
        </div>

        {isNFCStatsActive ? (
          <StatsDetail data={statsData.totalUserNfcStat} isNFC={true} />
        ) : null}
        {isQRCodeStatsActive ? (
          <StatsDetail data={statsData.totalTeamQRStat} isQRCode={true} />
        ) : null}
        {isFunctionsStatsActive ? (
          <StatsDetail data={statsData.totalFunctionQRStat} />
        ) : null}
      </div> */}
      {/* <div className="row">
        <div className="col-12 col-md-4">
          <Card className="text-center border-0">
            <Card.Body>
              <Card.Title>NFC Stat</Card.Title>
              <div class="progress-container mx-auto">
                <div class="progress-value">
                  <h6>{statsData?.totalUserNfcStatCount}</h6>
                  <p>Time Taps</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 col-md-4">
          <Card>
            <Card.Body>
              <Card.Title>QR Code Scan</Card.Title>
              <Card.Text></Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div> */}
      <div className="row g-4 mb-4">
        <div className="col-12 col-md-3">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="analyticsCardImg">
                  <img src={nfc} alt="NFC" />
                </div>
                <div>
                  <Card.Title>{statsData?.totalUserNfcStatCount}</Card.Title>
                  <p>NFC Stat</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 col-md-3">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="analyticsCardImg">
                  <img src={qrscan} alt="NFC" />
                </div>
                <div>
                  <Card.Title>{statsData?.totalFunctionQRStatCount}</Card.Title>
                  <p>QR Code Scan</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row g-4">
        <div className="col-12 col-md-6">
          <Card className="border-0 analyticsCard">
            <Card.Body>
              <Bar data={data} options={options} />
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserStats;
